import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export const formatDubaiDateTime = (
  date: string | Date | null | undefined,
  format: string = "DD - MMM - YYYY | hh:mm A"
): string => {
  if (!date) return "";
  return dayjs(date).tz("Asia/Dubai").format(format);
};

// Time only
export const formatDubaiTime = (
  date: string | Date | null | undefined,
  format: string = "hh:mm A"
): string => {
  if (!date) return "";
  return dayjs(date).tz("Asia/Dubai").format(format);
};

// Date only
export const formatDubaiDate = (
  date: string | Date | null | undefined,
  format: string = "DD - MMM - YYYY"
): string => {
  if (!date) return "";
  return dayjs(date).tz("Asia/Dubai").format(format);
};
